export function isHexColor(color: string, defaultVal: string): string {
   const hexRegex = /^#[0-9a-fA-F]{6}$/;
   return hexRegex.test(color) ? color : defaultVal;
}